/**
 * Iter 103: small "✎ Edit rate" pill rendered next to any builder
 * dropdown that's bound to a `component_rate_tables` row. Deep-links
 * to /component-rates?component={c}&highlight={rate_id} which scrolls
 * the matching row into view and pulses it — so the operator can hop
 * straight from a quote line to the catalogue entry, tweak the $/m or
 * supply cost, and the change cascades to every appraisal using that
 * rate row.
 */
import React from 'react';
import { Edit3 } from 'lucide-react';

export default function EditRateLink({ component, rateId, testid, label = 'Edit rate' }) {
  if (!rateId) return null;
  const href = `/component-rates?component=${encodeURIComponent(component)}&highlight=${encodeURIComponent(rateId)}`;
  return (
    <a href={href} target="_blank" rel="noreferrer"
       data-testid={testid}
       title="Open this rate in the Component Rates catalogue (new tab)"
       className="inline-flex items-center gap-0.5 text-[9px] normal-case font-semibold text-emerald-700 hover:text-emerald-900 hover:underline whitespace-nowrap">
      <Edit3 size={9} /> {label}
    </a>
  );
}
